import FImg from "../common/FImg";
import PBtn from "../common/PBtn";

export default function HeroBanner({ tag, title, sub, b1, b2, ob1, ob2, img }) {
  return (
    <div style={{ position: "relative", overflow: "hidden", minHeight: 320 }}>
      <FImg src={img} h={320} placeholder="office" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", filter: "brightness(.25)" }} />
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg,rgba(10,22,50,.85),rgba(26,60,110,.6))" }} />
      <div style={{ position: "relative", padding: "64px 24px 56px", textAlign: "center", color: "#fff" }}>
        {tag && <span style={{ background: "rgba(232,89,60,.15)", color: "#F2A623", padding: "6px 16px", borderRadius: 24, fontSize: 11, fontWeight: 700, letterSpacing: 1.1, textTransform: "uppercase", border: "1px solid rgba(232,89,60,.25)" }}>{tag}</span>}
        <h1 style={{ fontSize: 36, fontWeight: 800, marginTop: 16, marginBottom: 12, lineHeight: 1.2, fontFamily: "'Playfair Display',Georgia,serif", letterSpacing: "-0.4px" }}>{title}</h1>
        <p style={{ color: "rgba(255,255,255,.8)", fontSize: 15.5, maxWidth: 580, margin: "0 auto 28px", lineHeight: 1.75 }}>{sub}</p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <PBtn onClick={ob1}>{b1}</PBtn>
          {b2 && <button onClick={ob2} style={{ background: "rgba(255,255,255,.1)", color: "#fff", border: "1.5px solid rgba(255,255,255,.3)", padding: "12px 28px", borderRadius: 9, fontWeight: 600, fontSize: 14.5, cursor: "pointer", transition: "all .15s" }}>{b2}</button>}
        </div>
      </div>
    </div>
  );
}
